"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GLFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_89)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_89`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.35999 0H29.64V24H-6.35999V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M29.64 0V12H-6.35999V0H29.64Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.67865 20.2807C11.2442 20.2807 14.9453 16.5796 14.9453 12.014C14.9453 7.44849 11.2442 3.74738 6.67865 3.74738C2.1131 3.74738 -1.58801 7.44849 -1.58801 12.014C-1.58801 16.5796 2.1131 20.2807 6.67865 20.2807Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.58801 12C-1.58801 7.43158 2.11725 3.73334 6.67865 3.73334C11.2471 3.73334 14.9453 7.4386 14.9453 12",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_89`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GLFlag };
